<div class="container-xl trademark-policy">

  <div *ngIf="!officialMempoolSpace">
    <p>This website is operated by an individual member of the Bitcoin community, and is not affiliated with Mempool Space K.K.</p>
    <p>Please view the Trademark Policy and Guidelines for The Mempool Open Source Project at <a href="https://mempool.space/trademark-policy">https://mempool.space/trademark-policy</a>.</p>
  </div>

  <div *ngIf="officialMempoolSpace">
    <h2>Trademark Policy and Guidelines</h2>
    <h5>The Mempool Open Source Project &trade;</h5>
    <h6>Updated: July 19, 2021</h6>
    <br>

    <div class="text-left">

      <ol>

        <li>Introduction</li>

        <br>

        <p>Thank you for your interest in The Mempool Open Source Project (“Project”). While our software is available under an open source software license, the copyright license does not include an implied right or license to use our trademarks. This Policy (the “Policy”) outlines the allowable use of all trademarks and service marks, whether word marks, logos or trade dress (collectively, the "Marks"), owned by Mempool Space K.K. (“Mempool”).</p>

        <p>The role of trademarks is to provide assurance about the quality of the products or services with which the trademark is associated. Therefore, because an open source license allows your unrestricted modification of the copyrighted software, we cannot be sure that your modifications to the software are ones that will not be misleading if distributed under the same name. Instead, this Policy describes the circumstances under which you may use our Marks.</p>

        <p>In this Policy, we are not trying to limit the lawful use of our Marks, but rather describe for you what we consider the parameters of lawful use to be. Trademark law can be ambiguous, so we hope to provide enough clarity for you to understand whether we will consider your use licensed or non-infringing.</p>

        <p>The Marks covered by this Policy are either registered trademarks or trademarks of Mempool in Japan, the United States, and/or other countries. The sections that follow describe uses of the Marks that are allowed without additional permission from us. If you want to use our Marks in ways that are not described in this Policy, please see "Where to get further information" below for contact information.</p>

        <p>Any use that does not comply with this Policy or for which we have not separately provided written permission is not a use that we have approved. We reserve the right to revoke permission for any of the approved uses set forth in this Policy at any time. This Policy may change from time to time and all updates will be posted on this page.</p>

        <br>

        <li>Our Commitment to Open Source Principles</li>

        <br>

        <p>We want to encourage and facilitate the use of our Marks by the community but do so in a way that still ensures that the Marks are meaningful as a source and quality indicator for our organization and its associated goods and services. This will allow us to continue to embody the high reputation of our projects and the community associated with them.</p>

        <p>As such, this Policy strives to strike the proper balance between: 1) our need to ensure that our Marks remain reliable indicators of quality, 2) our need to ensure that we preserve the integrity of the community which these Marks represent; and 3) our community members' desire to be full participants in the Project.</p>

        <br>

        <li>Trademarks Subject to the Policy</li>

        <br>

        <ol>

          <li>Our Word Trademarks and Service Marks ("Word Marks"):</li>

          <br>

          <div class="text-center" style="max-width: 350px">
            <table class="table table-bordered">
              <tbody>
                <tr><td>Mempool Space K.K.</td></tr>
                <tr><td>The Mempool Open Source Project</td></tr>
                <tr><td>mempool.space</td></tr>
              </tbody>
            </table>
          </div>

          <br>

          <li>Our Logos (“Logos”):</li>

          <br>

          <div>

            <img src="/resources/mempool-logo-bigger.png" style="width: 300px; max-width: 80%">
            <br><br>
            <p>The mempool Logo</p>
            <br><br>

            <img src="/resources/mempool-space-logo-bigger.png" style="width: 300px; max-width: 80%">
            <br><br>
            <p>The mempool.space Vertical Logo</p>
            <br><br>

            <img src="/resources/mempool-space-logo-horizontal.png" style="width: 450px; max-width: 80%">
            <br><br>
            <p>The mempool.space Horizontal Logo</p>
            <br><br>

            <img src="/resources/mempool-tube.png" style="width: 100px">
            <br><br>
            <p>The mempool Square Logo</p>
            <br><br>

            <img src="/resources/mempool-blocks.png" style="width: 500px; max-width: 80%">
            <br><br>
            <p>The mempool Blocks Logo</p>
            <br><br>

          </div>

          <br>

          <li>The Unique Visual Styling of our Website ("Trade Dress")</li>

          <br>

          <div class="row">
            <div class="col-md-3 circle" style="color: #2F3246"></div>
            <div class="col-md-9" style="margin: auto">
              CMYK: 9%  8%  0% 73%
              <br><br>
              RGB:  47,  50,  70
              <br><br>
              HEX: #2F3246
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 circle" style="color: #8F5FF6"></div>
            <div class="col-md-9" style="margin: auto">
              CMYK: 40% 59% 0%  4%
              <br><br>
              RGB: 143,  95, 246
              <br><br>
              HEX: #8F5FF6
            </div>
          </div>

          <div class="row">
            <div class="col-md-3 circle" style="color: #80C2E1"></div>
            <div class="col-md-9" style="margin: auto">
              CMYK: 38% 12% 0% 12%
              <br><br>
              RGB: 128, 194, 225
              <br><br>
              HEX: #80C2E1
            </div>
          </div>

        </ol>

        <br>

        <li>Universal Considerations for All Uses</li>

        <br>

        <p>Whenever you use one of the Marks, you must always do so in a way that does not mislead anyone, either directly or by omission, about exactly what they are getting and from whom. The law reflects this requirement in two major ways described in more detail below: it prohibits creating a "likelihood of confusion" but allows for "nominative use." For example, you cannot say you are distributing the mempool.space software when you're distributing a modified version of it, because people would be confused when they are not getting the same features and functionality they would get if they downloaded the software directly from us. You also cannot use our logo on your website in a way that suggests that your website is an official website or that we endorse your website. You can, though, say you like the mempool.space software, that you participate in the mempool.space community, that you are providing an unmodified version of the mempool.space software, or that you wrote a book describing how to use the mempool.space software.</p>

        <p>This fundamental requirement, that it is always clear to people what they are getting and from whom, is reflected throughout this Policy. It should also serve as your guide if you are not sure about how you are using the Marks.</p>

        <p>In addition:</p>

        <p>You may not use the Marks in association with the use or distribution of software if you are also not in compliance with the copyright license for the software.</p>

        <p>You may not use or register, in whole or in part, the Marks as part of your own trademark, service mark, domain name, company name, trade name, product name or service name.</p>

        <p>Trademark law does not allow your use of names or trademarks that are too similar to ours. You therefore may not use an obvious variation of any of our Marks or any phonetic equivalent, foreign language equivalent, takeoff, or abbreviation for a similar or compatible product or service.</p>

        <p>You agree that you will not acquire any rights in the Marks and that any goodwill generated by your use of the Marks inures solely to our benefit.</p>

        <br>

        <li>Use for Software</li>

        <br>

        <ol>

          <li>Uses We Consider Non-Infringing</li>

          <br>

          <ol>

            <li>Distribution of Unmodified Source code or Unmodified Executable Code We Have Compiled</li>

            <br>

            <p>When you redistribute an unmodified copy of our software, you are not changing the quality or nature of it. Therefore, you may retain the Word Marks and the Logos we have placed on the software to identify your redistribution – – whether that redistribution is made by optical media, memory stick or download of unmodified source and executable code. This kind of use only applies if you are redistributing an official distribution from this Project that has not been changed in any way.</p>

            <li>Distribution of Executable Code That You Have Compiled, or Modified Code</li>

            <br>

            <p>You may use the Word Marks, but not the Logos, to truthfully describe the origin of the software that you are providing, that is, that the code you are distributing is a modification of our software. You may say, for example, that "this software is derived from the source code for mempool.space."</p>

            <p>Of course, you can place your own trademarks or logos on versions of the software to which you have made substantive modifications, because by modifying the software you have become the origin of that exact version. In that case, you should not use our Logos, and you should remove all of our Logo data files from your modified version of our software.</p>

            <li>Statements About Compatibility, Interoperability or Derivation</li>

            <br>

            <p>You may use the Word Marks, but not the Logos, to truthfully describe the relationship between your software and ours. Our Mark should be used after a verb or preposition that describes the relationship between your software and ours.</p>

            <p>You may say, for example, "Bob's software for mempool.space" but may not say "Bob's mempool.space software." Some other examples that may work for you are:</p>

            <ul>
              <li>[Your software] works with mempool.space.</li>
              <li>[Your software] uses mempool.space.</li>
              <li>[Your software] is powered by mempool.space.</li>
              <li>[Your software] runs on mempool.space.</li>
              <li>[Your software] for use with mempool.space.</li>
              <li>[Your software] for mempool.space.</li>
            </ul>

          </ol>

          <br>

          <li>Uses for Which We Are Granting a License</li>

          <br>

          <ol>

            <li>Distribution of Modified Software</li>

            <br>

            <p>You may use the Word Marks and the Logos for the distribution of executable code on the condition that it is made from official Project source code using the procedure documented for creating an executable found on the Project’s website.</p>

            <li>Distribution of Software Preloaded on Hardware</li>

            <br>

            <p>You may use the Word Marks and the Logos in association with hardware devices on the condition that the executable installed on the device is the official source executable for the Project, and that you do not suggest that the Project is the source of the hardware device itself but rather than the Marks are for the software incorporated into the device.</p>

          </ol>

          <li>Uses We Consider Infringing Without Seeking Further Permission From Us</li>

          <br>

          <p>We will likely consider using the Marks in a software distribution that combines our software with any other software program an infringement of our Marks. We would consider your software "combined" with ours if you create a single executable for both software programs, as well as if by installing our software it automatically installs yours. We would not consider your software "combined" with ours if it is on the same media but requires separate, independent action to install it.</p>

        </ol>

        <li>Use for Non-Software Goods and Services</li>

        <br>

        <ol>

          <li>Uses We Consider Non-Infringing</li>

          <br>

          <ol>

            <li>Websites</li>

            <br>

            <p>You may use the Word Marks and Logos, but not the Trade Dress, on your webpage to show your support for the Project as long as:</p>

            <ul>

              <li>Your own branding or naming is more prominent than any Project Marks;</li>

              <li>The Logos hyperlink to the Project website;</li>

              <li>The site does not mislead customers into thinking that either your website, service, or product is our website, service, or product; and</li>

              <li>The site clearly states that you are not affiliated with or endorsed by the Project.</li>

            </ul>

            <br>

            <li>Publications and Presentations</li>

            <br>

            <p>You may use the Word Marks in book and article titles, and the Logo in illustrations within the document, if the use does not suggest that we have published, endorse, or agree with your work.</p>

            <li>App Stores</li>

            <br>

            <p>You may use the Word Marks and Logos, but not the Trade Dress to indicate that your app is built from The Mempool Open Source Project as long you include the phrases "mempool.space" or "The Mempool Open Source Project" in your description.</p>

          </ol>

          <li>Uses We Consider Infringing Without Seeking Further Permission From Us</li>

          <br>

          <p>We will likely consider using the Marks as part of a domain name or subdomain an infringement of our Marks, with the exception of the hostname component using the following naming convention: https://mempool.[HOSTNAME].[TLD]/</p>

          <p>We would likely consider using the Marks on promotional goods or commercial goods an infringement of our Marks. "Promotional goods" are non-software goods that use the Marks and that are intended to advertise the Project, promote the Project, or show membership in the Project community.</p>

        </ol>

        <li>General Information</li>

        <br>

        <ol>

          <li>Trademark Marking and Legends</li>

          <br>

          <p>The first or most prominent mention of a Mark on a webpage, document, packaging, or documentation should be accompanied by a symbol indicating whether the mark is a registered trademark ("®") or an unregistered trademark ("TM").</p>

          <p>Also, if you are using our Marks in a way described in the sections "Uses for Which We Are Granting a License," you must include the following trademark attribution at the foot of the webpage where you have used the Mark (or, if in a book, on the credits page), on any packaging or labeling, and on advertising or marketing materials:</p>

          <p>“The Mempool Space K.K.&trade;, The Mempool Open Source Project&trade;, mempool.space&trade;, the mempool logo&reg;, the mempool.space logos&trade;, the mempool square logo&reg;, and the mempool blocks logo&trade; are either registered trademarks or trademarks of Mempool Space K.K in Japan, the United States, and/or other countries, and are used with permission. Mempool Space K.K. has no affiliation with and does not sponsor or endorse the information provided herein.”</p>

          <li>What to Do When You See Abuse</li>

          <br>

          <p>If you are aware of any confusing use or misuse of the Marks in any way, we would appreciate you bringing this to our attention. Please contact us as described below so that we can investigate it further.</p>

          <li>Where to Get Further Information</li>

          <br>

          <p>If you have any questions about this Policy, would like to speak with us about the use of our Marks in ways not described in the Policy, or see any abuse of our Marks, please email us at &lt;legal@mempool.space&gt;</p>

        </ol>

        <li>General Considerations About Trademarks and Their Use</li>

        <br>

        <ol>

          <li>What is a Trademark?</li>

          <br>

          <p>A trademark is a word, phrase, symbol or design, or a combination of words, phrases, symbols or designs, that identifies and distinguishes the source of the goods of one party from those of others.</p>

          <p>A service mark is the same as a trademark, except that it identifies and distinguishes the source of a service rather than a product.</p>

          <p>"Trade dress" or "get up" refers to the look and feel of the packaging, which in this context can include the layout, colors, images, and design choices in a web page.</p>

          <p>Throughout this Policy, the terms "trademark" and "mark" refer to both trademarks, service marks and trade dress. However, the use of a word is "not as a trademark" when it is used functionally as part of the software program, for example, in a file, folder, directory, or path name. Use in this way is not a trademark infringement.</p>

          <li>What is "Likelihood of Confusion"?</li>

          <br>

          <p>There is trademark infringement if your use of a trademark has created a "likelihood of confusion." This means using a trademark in a way that will likely confuse or deceive the relevant consuming public about the source of a product or service using the mark in question.</p>

          <li>What is "Nominative" Use?</li>

          <br>

          <p>So-called "nominative use" (or "nominative fair use"), which is the name of the doctrine under U.S. trademark law, allows the use of another's trademark where it is necessary for understanding. Other countries' trademark laws also have similar provisions.</p>

        </ol>

        <li>Proper Trademark Use</li>

        <br>

        <p>You should follow these rules when engaging in proper use of our Marks.</p>

        <ol>

          <li>Use of Our Marks in Text</li>

          <br>

          <ol>

            <li>Always use our Marks in their exact form with the correct spelling, neither abbreviated, hyphenated, or combined with any other word or words.</li>
            <br>
            <p>Unacceptable: Mempool-Space</p>
            <p>Acceptable: mempool.space</p>

            <li>Don't pluralize our Marks.</li>
            <br>
            <p>Unacceptable: I have two mempool.space’s running on my computer.</p>
            <p>Acceptable: I have two mempool.space explorers running on my computer.</p>

            <li>Don't use "a" or "the" to refer to an instance of our Mark.</li>
            <br>
            <p>Unacceptable: I installed a Mempool Open Source on my mom's computer.</p>
            <p>Acceptable: I installed mempool.space on my mom's computer.</p>

            <li>Always use our Marks as an adjective modifying a noun.</li>
            <br>
            <p>Unacceptable: This is a Mempool Open Source. Anyone can install it.</p>
            <p>Acceptable: This is mempool.space. Anyone can install it.</p>

            <li>Don't use our Marks as a verb. Trademarks are products or services, never actions.</li>
            <br>
            <p>Unacceptable: I Mempool Space'd my computer today.</p>
            <p>Acceptable: I installed mempool.space on my computer today.</p>

            <li>Don't use our Marks as a possessive. Instead, the following noun should be used in possessive form or the sentence reworded so there is no possessive.</li>
            <br>
            <p>Unacceptable: mempool.space’s web interface is very clean.</p>
            <p>Acceptable: The mempool.space web interface is very clean.</p>

          </ol>

          <li>Use of Logos</li>

          <br>

          <p>You may not change any Logo except to scale it. This means you may not add decorative elements, change the colors, change the proportions, distort it, add elements, or combine it with other logos.</p>

          <p>However, when the context requires the use of black-and-white graphics and the logo is color, you may reproduce the logo in a manner that produces a black-and-white image.</p>

        </ol>

      </ol>

      <p>EOF</p>

      <p>These guidelines are based on the <a href="http://www.modeltrademarkguidelines.org">Model Trademark Guidelines</a>, used under a <a href="https://creativecommons.org/licenses/by/3.0/deed.en_US">Creative Commons Attribution 3.0 Unported license</a>.</p>

    </div>

  </div>

  <br><br>

</div>
